import {
  Spin, List, Tag, Button,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useRequest } from 'ahooks';
import { isEmpty, isNull } from 'lodash';
import moment from 'moment';
import EmptyImg from '@/components/EmptyImg/EmptyImg';
import './DeclarationNotice.less';
import { getDeclarationNoticeList } from '@/services/agriculturalSubsidies';

/**
 * 申报通知
 * */
export default function DeclarationNotice() {
  const Navigate = useNavigate();
  const [list, setList] = useState({});

  const { run, loading } = useRequest(getDeclarationNoticeList, {
    onSuccess(res) {
      setList(res);
    },
  });

  function getData(e) {
    run({ ...e });
  }

  function onChange(page, size) {
    getData({ pageNum: page, pageSize: size });
  }

  function handleChange(id) {
    Navigate(`/agriculturalSubsidies/detail?id=${id}`);
  }

  return (
    <div className="bank-product">
      <Spin spinning={loading}>
        {
          isEmpty(list?.items) ? (<EmptyImg height={300} />) : (
            <div className="product-list">
              <List
                loading={loading}
                itemLayout="vertical"
                dataSource={list?.items}
                rowKey="id"
                pagination={{
                  onChange,
                  current: list?.pageNum,
                  total: list?.totalRows,
                  showTotal: (total) => `总计： ${total}条`,
                }}
                bordered={false}
                renderItem={(item) => (
                  <List.Item
                    extra={
                      (
                        <Button type="primary" className="ld-product-btn" onClick={() => handleChange(item.id)}>
                          进入申报
                        </Button>
                      )
                    }
                    className="ld-product-item"
                  >
                    <List.Item.Meta
                      title={<span>{item.title}</span>}
                      description={(
                        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {new DOMParser().parseFromString(item.content, 'text/html').body.textContent}
                        </div>
                      )}
                    />
                    <div style={{ display: 'flex' }}>
                      <Tag color="orange">
                        {item.year}
                        年度
                      </Tag>
                      <Tag color="blue">
                        申报截止日期：
                        {isNull(item.filingDeadline) ? '-' : moment(item.filingDeadline).format('YYYY-MM-DD')}
                      </Tag>
                    </div>
                  </List.Item>
                )}
              />
            </div>
          )
        }
      </Spin>
    </div>
  );
}
